import styles from "./app.module.css";
import { HelmetProvider } from "react-helmet-async";
import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import MainPage from "../../pages/main/main";
import Company from "../../pages/company/company";
import DonaPage from "../dona/dona";

function App() {
  useEffect(() => {
    document.title = "Lily-Dance";
  }, []);
  const pathname = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <HelmetProvider>
      <div className={styles.app}>
        <Routes>
          <Route path="/" element={<Company />} />
          <Route path="/company" element={<MainPage />} />
          <Route path="/dance" element={<DonaPage />} />
        </Routes>
      </div>
    </HelmetProvider>
  );
}

export default App;
